export const setExchanges = exchanges => {
  return {
    type: 'SET_EXCHANGES',
    payload: exchanges,
  }
}
